/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { Analytics } from '../../../analytics/sendAnalyticsEvent';
import { ANALYTICS_EVENTS } from '../../../constants';
import { formatBasePrice } from '../../../analytics/formatPrice';

const normalizeRemovedItems = (removedProducts = []) => {
  return (removedProducts || []).map((product) => {
    const sku = product.sku;

    const quantity = product.quantity || product.qty || 1;
    const unitPrice = product.unitPrice || product.price || 0;
    const basePrice = product.basePrice || +(unitPrice * quantity);

    return {
      quantity,
      price: { basePrice: formatBasePrice(basePrice) },
      productInfo: { sku },
    };
  }).filter((prod) => prod.productInfo.sku);
};

export default (set, get, payload) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const {
    experienceName = 'wall storage builder',
    feature = 'wall visualizer',
    interactionType = ANALYTICS_EVENTS.TRASH_CAN_BUTTON,
    removedProducts = [],
    emitClickEvent = false,
    emitItemRemovedEvent = true,
    emitRestartClickEvent = false,
  } = payload || {};

  const clickEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    content: {
      module: [{
        name: experienceName,
        feature,
        type: interactionType,
      }],
    },
  };
  const targetClickEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'remove-item', section: feature, target: interactionType },
  };
  if (emitClickEvent) {
    Analytics.sendAnalyticsEvent(clickEvent);
  }
  if (emitRestartClickEvent) {
    Analytics.sendAnalyticsEvent(targetClickEvent);
  }

  if (emitItemRemovedEvent) {
    const removedItems = normalizeRemovedItems(removedProducts);

    if (removedItems.length > 0) {
      const itemRemovedEvent = {
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'bundle remove' },
        item: removedItems,
      };
      Analytics.sendAnalyticsEvent(itemRemovedEvent);
    }

  }

}), false, { type: 'TRACK_REMOVE_PRODUCTS_EVENT' });
